<template>
    <div class="row">
        <div class="col-12 mb-3">
            <div class="card pt-4 mb-xl-9">
                <div class="card-header border-0">
                    <div class="card-title">
                        <h2 class="fw-bolder">{{ $t("pages.usefulTraining.title") }}</h2>
                    </div>
                </div>
                <div class="card-body pt-0">
                    <div class="fw-bolder fs-2">
                        <div class="fs-7 fw-normal text-muted">
                            {{ $t("pages.usefulTraining.desc") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div v-for="usefultraining in this.usefultrainings" v-bind:key="usefultraining.pk" class="col-4 mb-4">
            <div class="card bg-opacity-25 h-100 bg-info">
                <div class="card-header flex-nowrap border-0 pt-9">
                    <div class="card-title m-0">
                        <i class="fas fa-chalkboard-teacher fs-3 me-3 text-gray-900"></i>
                        <a href="#" class="fs-4 fw-bold text-hover-primary text-gray-900 m-0">{{ usefultraining.label }}</a>
                    </div>
                </div>
                <div class="card-body d-flex flex-column pb-8">
                    <div class="d-flex align-items-center fw-bold">
                        <a :href="usefultraining.link" target="_blank" class="btn btn-info btn-sm btn-light btn-active-light-info">Accéder à la formation </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import apiUsefulTraining from "@/core/services/UsefulTraining";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "usefultraining",
    components: {},
    data: function () {
        return {
            usefultrainings: [],
        };
    },
    methods: {
        getUsefulTraining() {
            apiUsefulTraining.getUsefulTraining().then((response) => {
                this.usefultrainings = response.data.usefultrainings;
            });
        },
    },
    setup() {
        const { t } = useI18n();
        setCurrentPageBreadcrumbs(t("pages.usefulTraining.title"), []);

        return { t };
    },
    watch: {
        "$i18n.locale": function () {
            setCurrentPageBreadcrumbs(this.t("pages.usefulTraining.title"), []);
        },
    },
    created() {
        this.getUsefulTraining();
    },
});
</script>
